// extracted by mini-css-extract-plugin
module.exports = {"LinkBoxList":"LinkBoxList_LinkBoxList__yl00N"};